import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, NgModuleRef} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpErrorResponse, HttpEventType} from '@angular/common/http';
import {of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {InvoiceService} from '../Services/invoice.service';
import {InvoiceAddendumListViewModel} from '../Services/invoiceAddendumListViewModel';
import {ToastrService} from 'ngx-toastr';
import { AddendumUploadComponent } from '../dialogs/addendum-upload/addendum-upload.component';


@Component({
  selector: 'app-invoice-addendum',
  templateUrl: './invoice-addendum.component.html',
  styleUrls: ['./invoice-addendum.component.less']
})
export class InvoiceAddendumComponent implements OnInit {
  @ViewChild('fileUpload', {static: false}) fileUpload: ElementRef;
  public files = [];

  constructor(public auth: AuthService,
    public readonly invoiceService: InvoiceService,
    private toasterService: ToastrService,
    private readonly modalService: NgbModal) { }

  ngOnInit() {
  }

  public uploadFile(file): void {

    const formData = new FormData();
    formData.append('file', file.data);

    file.inProgress = true;
    this.invoiceService.upload(formData).pipe(
      map(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            file.progress = Math.round(event.loaded * 100 / event.total);
            break;
          case HttpEventType.Response:
            return event;
        }
      }),
      catchError((error: HttpErrorResponse) => {
        file.inProgress = false;
        this.toasterService.error('Error uploading Addendum', '', {disableTimeOut: true, closeButton: true});
        return of(`${file.data.name} upload failed.`);

      })).subscribe((event: any) => {
        if (typeof (event) === 'object') {
          this.toasterService.success('Addendum Uploaded!');
        }
      },
      err => this.toasterService.error('Error uploading Addendum', '', {disableTimeOut: true, closeButton: true}));

  }

  public findAddendumFile(): void {
    this.files = [];

    const fileUpload = this.fileUpload.nativeElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({data: file, inProgress: false, progress: 0});
      }
      this.uploadFiles();
    };
    fileUpload.click();
  }

  public showDeleteAddendum(r: InvoiceAddendumListViewModel): boolean {

    const newDate = new Date();
    const existingDate = new Date(r.uploadedDate);

    newDate.setHours(newDate.getHours() - 24);

    if (existingDate > newDate) {
      return true;
    }

    return false;
  }

  public loadAddendum(){
    //AddendumUploadComponent
    const modalRef = this.modalService.open(AddendumUploadComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'ClientSliderUpdateModal';
  }

  public deleteAddendumImport(r: InvoiceAddendumListViewModel): void {

    this.invoiceService.deleteInvoiceAddendum(r.uploadedDate).subscribe((re: any) => {
        this.toasterService.success('Addendum Removed!');
      },
      err => this.toasterService.error('Error removing Addendum', '', {disableTimeOut: true, closeButton: true}));
  }

  private uploadFiles() {
    this.fileUpload.nativeElement.value = '';
    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }

}
